import { inject } from '@angular/core';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { of } from 'rxjs';

/**
 * Initial data resolver — runs before every authenticated layout route.
 *
 * Builds the navigation tree locally from the static navigation item
 * definitions filtered by the current user's role.
 *
 * Previously called five mock-backed services (messages, notifications,
 * quick-chat, shortcuts, navigation). Those Fuse demo services have been
 * removed from this resolver:
 *   - messages / notifications / shortcuts / quick-chat widgets are
 *     commented out in all layout templates and serve no real app function.
 *   - navigation is now built locally with no HTTP call.
 *
 * When RBAC is implemented, NavigationService.build() will also apply
 * permission-based filtering via RbacPermissionService before emitting.
 */
export const initialDataResolver = () => {
    inject(NavigationService).build();
    return of(true);
};
